import { html } from "lit";
import { formatHtml } from "@trumpf/ux.common-storybook";
import { Default as PageIntro } from "../../../partial-templates/page-intro/page-intro.stories";
import { renderPageTemplate } from "../../../../utils";

export default {
    title: "MyTrumpf/Page Templates/User Management/User Profile",
    parameters: {
        docs: {
            source: {
                transform: formatHtml,
            },
        },
    },
};

const Template = () => {
    return html`
        <div
            class="ux-t-container-full ux-iws-user-profile-tpl"
            id="subpage"
        >
            ${PageIntro({
                headline: "My Profile",
            })}
            <div class="ux-row">
                <div class="ux-col-12">
                    <ux-tab-container scroll-when-activated>
                        <ux-iws-async-tab
                            name="Personal Data"
                            tab-id="personal-data"
                            url="./mock-data/user-profile/personal-data.html"
                            class="ux-u-mt-s ux-u-mt-lg-l ux-u-mb-s"
                        ></ux-iws-async-tab>
                        <ux-iws-async-tab
                            name="Notification Settings"
                            tab-id="notification-settings"
                            url="./mock-data/user-profile/notification-settings.html"
                            class="ux-u-mt-s ux-u-mt-lg-l ux-u-mb-s"
                        /></ux-iws-async-tab>
                        <ux-iws-async-tab
                            name="Company Data"
                            tab-id="company-data"
                            url="./mock-data/user-profile/company-data.html"
                            class="ux-u-mt-s ux-u-mt-lg-l ux-u-mb-s"
                        /></ux-iws-async-tab>
                        <ux-iws-async-tab
                            name="Company Admin"
                            tab-id="company-admin"
                            url="./mock-data/user-profile/company-admin.html"
                            class="ux-u-mt-s ux-u-mt-lg-l ux-u-mb-s"
                        /></ux-iws-async-tab>
                        <ux-iws-async-tab
                            name="Permissions"
                            tab-id="permissions"
                            url="./mock-data/user-profile/permissions.html"
                            class="ux-u-mt-s ux-u-mt-lg-l ux-u-mb-s"
                        /></ux-iws-async-tab>
                        <ux-iws-async-tab
                            name="Change password"
                            tab-id="change-password"
                            url="./mock-data/user-profile/change-password.html"
                            class="ux-u-mt-s ux-u-mt-lg-l ux-u-mb-s"
                        /></ux-iws-async-tab>
                        <ux-iws-async-tab
                            name="Delete Account"
                            tab-id="delete-account"
                            url="./mock-data/user-profile/delete-account.html"
                            class="ux-u-mt-s ux-u-mt-lg-l ux-u-mb-s"
                        /></ux-iws-async-tab>
                    </ux-tab-container>
                </div>
            </div>
        </div>
    `;
};

export const Default = () => renderPageTemplate(() => Template());

const TemplateNotificationSettingsNoPermission = () => {
    return html`
        <div
            class="ux-t-container-full ux-iws-user-profile-tpl"
            id="subpage"
        >
            ${PageIntro({
                headline: "My Profile",
                text:
                    "Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident.",
            })}
            <div class="ux-row">
                <div class="ux-col-12">
                    <ux-tab-container scroll-when-activated>
                        <ux-iws-async-tab
                            name="Notification Settings"
                            tab-id="notification-settings"
                            url="./mock-data/user-profile/notification-settings-no-permission.html"
                            class="ux-u-mt-s ux-u-mt-lg-l ux-u-mb-s"
                        /></ux-iws-async-tab>
                    </ux-tab-container>
                </div>
            </div>
        </div>
    `;
};

export const NotificationSettingsNoPermission = () =>
    renderPageTemplate(() => TemplateNotificationSettingsNoPermission());

const TemplateNotificationSettingsPartPermission = () => {
    return html`
        <div
            class="ux-t-container-full ux-iws-user-profile-tpl"
            id="subpage"
        >
            ${PageIntro({
                headline: "My Profile",
                text:
                    "Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident.",
            })}
           <div class="ux-row">
                <div class="ux-col-12">
                    <ux-tab-container scroll-when-activated>
                        <ux-iws-async-tab
                            name="Notification Settings"
                            tab-id="notification-settings"
                            url="./mock-data/user-profile/notification-settings-part-permission.html"
                            class="ux-u-mt-s ux-u-mt-lg-l ux-u-mb-s"
                        /></ux-iws-async-tab>
                    </ux-tab-container>
                </div>
            </div>
        </div>
    `;
};

export const NotificationSettingsPartPermission = () =>
    renderPageTemplate(() => TemplateNotificationSettingsPartPermission());
